<template lang="pug">
div
  div.row.d-flex.justify-content-center.text-center.mb-5
    h4 Membership Card

  div.row.justify-content-center(v-if="error")
    p {{ error }}
  div.row.justify-content-center(v-else-if="!member")
    p Loading membership data...
  div.row.no-gutters.justify-content-center(v-if="member")
    div.col-md-7.col-lg-5
      div.row.justify-content-start
        div.left.no-line-height.mb-4.pl-2
          p NAME: {{member.firstName}} {{member.lastName}}
          p ID: {{member.igdaFinlandId}}

      div.row.justify-content-end
        div.right.no-line-height.mb-5.text-right.pr-2
          p(v-if="member.membershipType == 'Affiliate'") AFFILIATE: {{member.affiliateName}}
          p(v-else) TYPE: {{member.membershipType}}

          p(v-if="member.membershipType != 'Lifetime' && membershipStatus == 'VALID'") EXPIRES: {{member.validUntil | moment("MMMM YYYY")}}
          p(v-else-if="membershipStatus == 'EXPIRED'") EXPIRED: {{member.validUntil | moment("MMMM YYYY")}}
          p(v-else-if="member.membershipType == 'Lifetime'") EXPIRES: Never!

      div.row.justify-content-center.mb-5
        div.text-center
          div(v-if="member.membershipType == 'Lifetime' || membershipStatus == 'VALID'")
            fa-icon(icon="check-circle" size="7x").mb-4
            p MEMBERSHIP ACTIVE!
          div(v-else)
            fa-icon(icon="times-circle" size="7x").mb-4
            p MEMBERSHIP EXPIRED

      div.row.justify-content-center
        div.qr
          qrcode-vue(:value="member.igdaFinlandId.toString()" :size="200")
</template>

<style lang="sass">
$igda-red: rgb(203,42,45)
$igda-yellow: rgb(249,211,50)

.no-line-height
  p
    margin-bottom: 0

.left
  border-left-style: solid
  border-left-color: $igda-red
  color: $igda-yellow

.right
  border-right-style: solid
  border-right-color: $igda-yellow
  color: $igda-red

.qr
  border-style: solid
  border-width: thick
</style>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  data: function () {
    return {
      member: null,
      now: new Date(),
      error: null
    }
  },
  components: {
    QrcodeVue
  },
  computed: {
    membershipStatus: function () {
      if (this.member == null) return 'UNKNOWN'
      else if (this.member.membershipType === 'Lifetime') return 'LIFETIME'
      else if (this.member.validUntil > this.now) return 'VALID'
      else return 'EXPIRED'
    }
  },
  mounted: async function () {
    let apiUrl
    if (this.$route.params.hasOwnProperty('individual_id')) apiUrl = `/api/cards/individual/${this.$route.params.individual_id}`
    else if (this.$route.params.hasOwnProperty('affiliate_id')) apiUrl = `/api/cards/affiliate/${this.$route.params.affiliate_id}`

    if (!apiUrl) {
      this.member = {
        createdDate: new Date('2019-02-14T08:11:29.669Z'),
        membershipType: 'Lifetime',
        validUntil: new Date('2020-02-29T23:59:59.669Z'),
        firstName: 'Fake',
        lastName: 'Name',
        igdaFinlandId: 1337
      }
    } else {
      try {
        let res = await this.axios.get(apiUrl)
        this.member = res.data
        this.member.validUntil = new Date(this.member.validUntil)
        this.member.createdDate = new Date(this.member.createdDate)
      } catch (err) {
        this.error = err
      }
    }
  }
}
</script>
